import { render, staticRenderFns } from "./ApplicationPackaging.vue?vue&type=template&id=01ea64c8&scoped=true&"
import script from "./ApplicationPackaging_.js?vue&type=script&lang=js&"
export * from "./ApplicationPackaging_.js?vue&type=script&lang=js&"
import style0 from "./ApplicationPackaging.vue?vue&type=style&index=0&id=01ea64c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ea64c8",
  null
  
)

export default component.exports